import { TextInput } from '@dreryk/react-components';

import { magistralDrugTranslationKeys } from '../../../../../translations';
import { MagistralDrugCreateFormController } from '../../../magistralDrug/create/MagistralDrugCreateForm.types';

type AdditionalDetailsTextInputProps = Pick<MagistralDrugCreateFormController, 'register'>;

export const AdditionalDetailsTextInput = (props: AdditionalDetailsTextInputProps): JSX.Element => {
   return (
      <TextInput
         label={magistralDrugTranslationKeys.infoForIssuer}
         testId={'additionalDetails'}
         controller={props.register('additionalDetails', { maxLength: 200 })}
      />
   );
};
